export class Registration {
  public CID: number;
  public ContractNumber: string;
  public OldRegistrationNum: string;
  public NewRegistrationNum: string;
}



// WEBPACK FOOTER //
// ./src/app/models/Registration.ts